import React, { useEffect } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import { Container, Navbar, Nav, Button } from "react-bootstrap";
import AboutSection from "./AboutSection";
import Home from "./Home";
import BackgroundSlideshow from "./SlideShow";
import ProductTabs from "./ProductTabs";
import Services from "./Services";
import AquaFlowPromo from "./AquaFlowPromo";
import Piscina from "./Piscina";
import Boiler from "./Boiler";
import Aquecedor from "./Aquecedor";
import Coletor from "./Coletor";
import Bomba from "./Bomba";
import Calor from "./Calor";
import ProjectsSection from "./ProjectsSection";
import DifferentialsSection from "./DifferentialsSection";
import WhoWeAreSection from "./WhoWeAreSection";
import AboutPage from "./AboutUs";
import TestimonialsSection from "./TestimonialsSection";
import Logo from "../assets/logo.png";
import Bg1 from "../assets/bg1.jpg";
import Bg2 from "../assets/bg2.jpg";
import Bg3 from "../assets/bg3.jpg";
const images = [Bg1, Bg2, Bg3];

function Navalt() {
  const location = useLocation();

  useEffect(() => {
    const toggleAnimate = () => {
      if (document.visibilityState === "visible") {
        document.body.classList.add("animate");
      }
    };

    document.addEventListener("visibilitychange", toggleAnimate);
    // on mount, if already visible
    toggleAnimate();

    return () =>
      document.removeEventListener("visibilitychange", toggleAnimate);
  }, []);

  // Optionally clear and re-add 'animate' on route change to replay once
  useEffect(() => {
    document.body.classList.remove("animate");
    // small timeout to allow CSS reset
    setTimeout(() => document.body.classList.add("animate"), 50);
  }, [location.pathname]);

  return (
    <>
      <Navbar bg="light" expand="lg" className="p-3 nav-b2">
        <BackgroundSlideshow images={images} interval={3000} />
        <Container className="nav-bb">
          <Navbar.Brand as={Link} to="/" className="animated">
            <img src={Logo} height={100}></img>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="nav" className="animated" />
          <Navbar.Collapse id="nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/" className="animated">
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/about" className="animated">
                Sobre Nós
              </Nav.Link>
              <Nav.Link as={Link} to="/services" className="animated">
                Serviços
              </Nav.Link>
              <Nav.Link as={Link} to="/products" className="animated">
                Produtos
              </Nav.Link>
            </Nav>
            <a href="#contacts">
              <Button variant="primary" className="btn-contact animated">
                Contato
              </Button>
            </a>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Container>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutSection />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<ProductTabs />} />
          <Route path="/aquaflow" element={<AquaFlowPromo />} />
          <Route path="/aquecedor" element={<Aquecedor />} />
          <Route path="/piscina" element={<Piscina />} />
          <Route path="/boiler" element={<Boiler />} />
          <Route path="/coletor" element={<Coletor />} />
          <Route path="/bomba" element={<Bomba />} />
          <Route path="/calor" element={<Calor />} />
          <Route path="/projects" element={<ProjectsSection />} />
          <Route path="/assistencias" element={<DifferentialsSection />} />
          <Route path="/sobre-nos" element={<WhoWeAreSection />} />
          <Route path="/termos" element={<AboutPage />} />
          <Route path="/clientes" element={<TestimonialsSection />} />
        </Routes>
      </Container>
    </>
  );
}

export default Navalt;
